import { maximumMapBounds } from '../domain/camera.ts';
import { createBrowserCameraHashState } from './browser-camera-hash.ts';
import { createCameraNavigation, type CameraNavigation } from './camera-navigation.ts';
import { createSavedViewStore, type KeyValueStorage, type SavedViewScope } from './saved-view.ts';

export function resolveSavedViewScope(
  location: Pick<Location, 'hostname' | 'pathname'>,
): SavedViewScope {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return 'local';
  const preview = /^pr-(\d+)\.zugbiketrails-review\.pages\.dev$/u.exec(location.hostname);
  if (preview?.[1] !== undefined) return { previewPullRequest: Number(preview[1]) };
  if (location.pathname === '/next' || location.pathname.startsWith('/next/')) return 'candidate';
  return 'production';
}

export function createBrowserCameraNavigation(browserWindow: Window): CameraNavigation {
  const storage: KeyValueStorage = {
    getItem(key) {
      return browserWindow.localStorage.getItem(key);
    },
    setItem(key, value) {
      browserWindow.localStorage.setItem(key, value);
    },
  };
  return createCameraNavigation({
    hash: createBrowserCameraHashState(browserWindow, {
      bounds: maximumMapBounds,
      viewportHeight: () => browserWindow.innerHeight,
    }),
    saved: createSavedViewStore({
      bounds: maximumMapBounds,
      scope: resolveSavedViewScope(browserWindow.location),
      storage,
    }),
  });
}
